import { useCallback } from 'react';

const useSelection = (nodes, setNodes, selectedItems, setSelectedItems) => {
  const handleSelect = useCallback((id, isMultiSelect = false) => {
    if (!id) {
      setSelectedItems([]);
      return;
    }

    setSelectedItems(prev => {
      if (isMultiSelect) {
        return prev.includes(id) 
          ? prev.filter(item => item !== id)
          : [...prev, id];
      }
      return [id];
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleDragStart = useCallback((id) => {
    // Puedes añadir lógica adicional aquí si es necesario
  }, []);

  const handleDrag = useCallback((id, newPosition) => {
    setNodes(prevNodes => 
      prevNodes.map(node => 
        node.id === id ? { ...node, ...newPosition } : node
      )
    );
  }, [setNodes]);

  return { handleSelect, handleDragStart, handleDrag };
};

export default useSelection;